import { createContext } from 'react';

interface ButtonGroupContextValue {
  value?: { value?: number | string; label?: string };
  onClick?(value: { value?: number | string; label?: string }): void;
  activeButton?: { value?: number | string; label?: string };
}

export const ButtonGroupContext = createContext<ButtonGroupContextValue | null>(null);
export const ButtonGroupProvider = ButtonGroupContext.Provider;
